<section class="flex mb-4">
    <div class="flex-1 flex flex-col">
        <span class="span1 text-neutral-600 text-2xl font-semibold font-['Inter'] leading-normal">
            Resumen del Detalle de Conciliaciones
        </span>

    </div>
</section>
<div class="flex-1" id="dashboardSalesDetailContainer"></div>

<section class="mt-auto items-center flex">
    <a routerLink="/conciliaciones-v2"
        class="mx-auto w-60 px-[25px] py-[10px] bg-indigo-300 rounded-[14px] text-center items-center align-middle cursor-pointer hover:bg-indigo-400 transition-colors">
        <span class="text-white font-semibold font-['Inter']">
            Volver
        </span>
    </a>
</section>